import { motion } from "framer-motion";
import { ChromeBar, SilverOrb } from "@/components/Chrome";
import WarpField from "@/components/WarpField";

const PRINCIPLES = [
  { k: "01", t: "Art × Science", b: "Every frame is composition. Every cut, math. We treat the body in motion the same way a physicist treats light — with reverence." },
  { k: "02", t: "Family-First", b: "JITSUENT is the in-house production family of Joints & Jitsu. We shoot for the people, the gym, the culture. No outsourced eyes." },
  { k: "03", t: "Monochrome by Design", b: "Black-and-white is not aesthetic — it is honesty. Strip away the color and only the form, the grit, the truth remain." },
  { k: "04", t: "Ludicrous Speed", b: "From shoot to delivery — we ship at warp. Tournament Saturday becomes social Sunday." },
];

export default function About() {
  return (
    <div className="bg-black min-h-screen anim-fadeup" data-testid="about-page">
      <section className="relative border-b border-neutral-900 py-32 overflow-hidden">
        <div className="absolute inset-0 opacity-30"><WarpField density={100} speed={0.3} /></div>
        <div className="relative max-w-[1600px] mx-auto px-6 lg:px-12 grid grid-cols-12 gap-8">
          <div className="col-span-12 lg:col-span-8">
            <div className="font-mono text-[10px] tracking-[0.4em] text-neutral-500 mb-6">
              03 / MANIFESTO
            </div>
            <h1 className="font-bodoni font-black text-6xl md:text-8xl lg:text-[10rem] leading-[0.85]">
              We are the
              <br />
              <span className="italic">silver surfers</span>
              <br />
              of <span className="chrome-text">the mat</span>.
            </h1>
          </div>
          <div className="hidden lg:flex col-span-4 items-end justify-end">
            <SilverOrb size={220} />
          </div>
        </div>
      </section>

      <section className="border-b border-neutral-900 py-24">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12 grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-5 font-mono text-[10px] tracking-[0.4em] text-neutral-500">
            04 / WHO WE ARE
          </div>
          <div className="col-span-12 md:col-span-7 space-y-6 font-mono text-base text-neutral-300 leading-relaxed">
            <p>
              JITSUENT — short for <em>Jitsu Entertainment</em> — is the creative
              fight entertainment + media production arm of <a className="link-underline text-white" href="https://jointsnjitsu.com" target="_blank" rel="noreferrer">Joints &amp; Jitsu</a>.
            </p>
            <p>
              We capture the artistry of jiu-jitsu and the science of training at
              speeds that bend light. Black-and-white film, silver-chrome accents,
              and the kind of cinematic patience that turns competition into legend.
            </p>
            <p>
              From walk-out films to gym documentaries, athlete portraits to product
              campaigns — every project rolls through one family. <span className="italic">JOINT OSS.</span>
            </p>
          </div>
        </div>
      </section>

      <section className="border-b border-neutral-900 py-24">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-neutral-900">
            {PRINCIPLES.map((p, i) => (
              <motion.div
                key={p.k}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.08 }}
                className="bg-black p-10 lg:p-14"
                data-testid={`principle-${p.k}`}
              >
                <div className="font-mono text-[10px] text-neutral-600 tracking-widest mb-6">{p.k}</div>
                <h3 className="font-bodoni text-4xl mb-4">{p.t}</h3>
                <p className="font-mono text-sm text-neutral-500 leading-relaxed">{p.b}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-24 text-center">
        <ChromeBar className="w-24 mx-auto mb-8" />
        <h2 className="font-bodoni text-4xl md:text-6xl">
          <span className="italic">柔術.</span> <span className="chrome-text">Roll Forever.</span>
        </h2>
      </section>
    </div>
  );
}
